import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { SpinnerModule } from '../../../../shared';
import { ActionButtonModule } from '../../../../shared/components/action-button/action-button.module';
import { ReactiveFormInputFieldModule } from '../../../../shared/components/reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { LoginFormComponent } from './container/login-form.component';

@NgModule({
  declarations: [LoginFormComponent],
  imports: [
    CommonModule,
    NzIconModule,
    ReactiveFormsModule,
    I18nModule,
    UrlModule,
    RouterModule,
    ReactiveFormInputFieldModule,
    SpinnerModule,
    ActionButtonModule,
  ],
  exports: [LoginFormComponent],
})
export class LoginFormModule {}
